import { __assign, __read, __rest } from "tslib";
import * as React from 'react';
import { useMediaQuery, lgMediaQuery, } from '@mercell/use-media-query-react-hook';
import { usePopper } from 'react-popper';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import cx from 'classnames';
var popperPlacementStyles = function (placement, arrowStyles) {
    switch (placement) {
        case 'top':
            return arrowStyles
                ? 'bottom-0 after:-left-2 after:rotate-180'
                : 'mb-4';
        case 'bottom':
            return arrowStyles ? '-top-[10px] after:-left-[7px]' : 'mt-4';
        case 'left':
            return arrowStyles
                ? 'right-[3px] after:-top-[5px] after:rotate-90'
                : 'mr-4';
        case 'right':
            return arrowStyles
                ? '-left-[13px] after:-top-[6px] after:-rotate-90'
                : 'ml-4';
        default:
            return '';
    }
};
export var Tooltip = function (_a) {
    var _b, _c;
    var children = _a.children, message = _a.message, tooltipInnerWrapperClassName = _a.tooltipInnerWrapperClassName, tooltipMessageClassName = _a.tooltipMessageClassName, tooltipPopperWrapperClassName = _a.tooltipPopperWrapperClassName, tooltipArrowClassName = _a.tooltipArrowClassName, _d = _a.placement, placement = _d === void 0 ? 'auto' : _d, className = _a.className, rest = __rest(_a, ["children", "message", "tooltipInnerWrapperClassName", "tooltipMessageClassName", "tooltipPopperWrapperClassName", "tooltipArrowClassName", "placement", "className"]);
    var _e = __read(useState(false), 2), show = _e[0], setShow = _e[1];
    var _f = __read(useState(null), 2), referenceElement = _f[0], setReferenceElement = _f[1];
    var _g = __read(useState(null), 2), popperElement = _g[0], setPopperElement = _g[1];
    var _h = __read(useState(null), 2), arrowElement = _h[0], setArrowElement = _h[1];
    var _j = usePopper(referenceElement, popperElement, {
        placement: placement,
        modifiers: [{ name: 'arrow', options: { element: arrowElement } }],
    }), styles = _j.styles, attributes = _j.attributes;
    // there is time user can be out of the component (during the hovering or changing focus) and not close it
    var closeTimeout;
    var mobileProperties = {
        onFocus: function () {
            if (closeTimeout !== null)
                clearTimeout(closeTimeout);
            setShow(true);
        },
        onBlur: function () {
            closeTimeout = setTimeout(function () { return setShow(false); }, 50);
        },
        tabIndex: 1,
    };
    var innerMobileProperties = {
        onTouchStart: function () {
            setShow(!show);
        },
    };
    var desktopOpen = function () {
        if (closeTimeout !== null)
            clearTimeout(closeTimeout);
        setShow(true);
    };
    var desktopClose = function () {
        closeTimeout = setTimeout(function () { return setShow(false); }, 50);
    };
    var desktopProperties = {
        onMouseOver: desktopOpen,
        onMouseLeave: desktopClose,
        onFocus: desktopOpen,
        onBlur: desktopClose,
        tabIndex: 0,
    };
    var isNotDesktop = useMediaQuery(lgMediaQuery);
    var properties = isNotDesktop ? mobileProperties : desktopProperties;
    var childrenProperties = isNotDesktop ? innerMobileProperties : {};
    return (React.createElement("div", __assign({}, rest, properties, { className: twMerge('tooltip-wrapper', className) }),
        React.createElement("div", __assign({}, childrenProperties, { className: "tooltip-children", ref: setReferenceElement }), children),
        show && (React.createElement("div", __assign({}, attributes.popper, { className: twMerge(cx('z-10', tooltipPopperWrapperClassName, popperPlacementStyles((_b = attributes.popper) === null || _b === void 0 ? void 0 : _b['data-popper-placement'], false))), ref: setPopperElement, style: styles.popper }),
            React.createElement("div", { className: twMerge('py-[1px] px-0 min-w-[150px] max-w-[400px] whitespace-normal w-fit-content rounded-half bg-mirage text-white text-center relative', tooltipInnerWrapperClassName) },
                React.createElement("div", { className: twMerge('my-[6px] mx-[10px] text-body', tooltipMessageClassName), role: "tooltip" }, message),
                React.createElement("div", { ref: setArrowElement, style: styles.arrow, className: twMerge("after:content-[''] after:absolute after:border-x-8 after:border-x-transparent after:border-b-[10px] after:border-b-mirage", popperPlacementStyles((_c = attributes.popper) === null || _c === void 0 ? void 0 : _c['data-popper-placement'], true), tooltipArrowClassName) }))))));
};
export default Tooltip;
